import { Box, Button, Container, Grid, Modal, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import uploadImage from "../../../image/wmremove-transformed-Photorooms.jpg";
import {
  barClubAddRequest,
  barClubResetState,
} from "../../../redux/barclub/BarClubAction";
import { wholesalerViewAllRequest } from "../../../redux/wholesaler/WholesalerAction";
import {
  handleAddFileChange,
  handleAddProofChange,
  removeImageAdd,
  removeProofImageAdd,
} from "../../constant/commonFileUpload";
import "../../../style/style.css";
import { StyledContainer, styles } from "../../components/formStyles";
import { formatToAMPM } from "../../constant/commonTimeFormat";
import CustomButton from "../../constant/commonButton";
import ReusableFormFields from "../../constant/reusableFormFields";
import { mapBackendMessage } from "../../notification/BackendMessage";
import CommonDialog from "../../notification/Dialogbox";
import CommonSnackbar from "../../notification/Snackbar";
import CloseIcon from "@mui/icons-material/Close";
import pdfImage from "../../../image/pdf.jpg";
import { APP_LINKS } from "../../global/wholeSalerMenuItems";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const AddClub = () => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    setError,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [imageFileName, setImageFileName] = useState("");
  const [proofFileName, setProofFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [proofSelectedFile, setProofSelectedFile] = useState([]);
  const [imagePreview, setImagePreview] = useState([]);
  const [proofPreview, setProofPreview] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(true);
  const fileInputRef = useRef(null);
  const proofInputRef = useRef(null);

  const [openMap, setOpenMap] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const GOOGLE_MAPS_API_KEY = "AIzaSyCvQUUv4zUJSZdBGgDb38rZZakE7qyutZ8";

  const addBarClubState = useSelector(
    (state) => state?.barClub?.addBarClub || {}
  );
  const WholesalerId = useSelector(
    (state) => state?.values?.loginValues?.[0]?.wholesaler_id
  );
  useEffect(() => {
    dispatch(wholesalerViewAllRequest());
  }, [dispatch]);

  const inputFields = [
    {
      name: "name",
      label: "Bar/Club Name",
      rules: { required: "Name is required" },
    },
    {
      name: "first_name",
      label: "First Name",
      rules: { required: "First Name is required" },
    },
    {
      name: "last_name",
      label: "Last Name",
      rules: { required: "Last Name is required" },
    },
    {
      name: "email",
      label: "Email Address",
      rules: {
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email format",
        },
      },
    },
    {
      name: "contact",
      label: "Phone No",
      rules: {
        required: "Phone No is required",
        pattern: {
          value: /^\d{8,}$/,
          message: "Invalid Phone Number",
        },
      },
    },
    {
      name: "address",
      label: "Address",
      size: "extraLarge",
      rules: { required: "Address is required" },
    },
    {
      name: "google_map_location",
      label: "Google Map Location",
      rules: {
        required: "Google Map Location is required",
      },
    },
    {
      name: "latitude",
      label: "Latitude",
      rules: {
        required: "Latitude is required",
      },
      readOnly: true,
    },
    {
      name: "longitude",
      label: "Longitude",
      rules: {
        required: "Longitude is required",
      },
      readOnly: true,
    },
    {
      name: "postal_code",
      label: "Postal Code",
      rules: {
        required: "Postal Code is required",
        pattern: {
          value: /^[0-9]+$/,
          message: "Only numbers are allowed",
        },
      },
    },
    {
      name: "shop_open_and_close_time",
      label: "Shop Opening Time",
      type: "group",
      fields: [
        {
          name: "open_time",
          label: "Open Time",
          type: "time",
          format: formatToAMPM,
        },
        {
          name: "close_time",
          label: "Shop Closing Time",
          type: "time",
          format: formatToAMPM,
        },
      ],
    },
  ];

  const handleImageUpload = (event) => {
    handleAddFileChange(event, setSelectedFile, setImagePreview, showSnackbar);
  };

  const handleProofUpload = (event) => {
    handleAddProofChange(
      event,
      setProofSelectedFile,
      setProofPreview,
      showSnackbar
    );
  };

  const handleImage = () => {
    if (selectedFile) {
      showSnackbar(
        `Product details saved with file: ${selectedFile.name}`,
        "success"
      );
    } else {
      showSnackbar("Please choose a file before saving.", "error");
    }
  };

  const proofImage = () => {
    if (proofSelectedFile) {
      showSnackbar(
        `Product details saved with file: ${proofSelectedFile.name}`,
        "success"
      );
    } else {
      showSnackbar("Please choose a file before saving.", "error");
    }
  };

  const handleCancel = () => {
    reset({
      wholesaler_id: "",
      name: "",
      first_name: "",
      last_name: "",
      type_of_quantity: "",
      wholesaler_name: "",
      address: "",
      google_map_location: "",
      latitude: "",
      longitude: "",
      postal_code: "",
      shop_open_and_close_time: "",
      open_time: "",
      close_time: "",
      region: "",
    });
    setSelectedFile([]);
    setImagePreview(null);
    setImageFileName("");
    if (fileInputRef.current) fileInputRef.current.value = "";

    setProofSelectedFile(null);
    setProofPreview(null);
    setProofFileName("");
    if (proofInputRef.current) proofInputRef.current.value = "";
  };

  const handleOpenMap = () => {
    setOpenMap(true);
  };

  const handleCloseMap = () => {
    setOpenMap(false);
    setLatitude(null);
    setLongitude(null);
    setLoading(false);
    setAddress("");
  };

  const fetchAddress = async (lat, lng) => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data.results && data.results.length > 0) {
        const formattedAddress = data.results[0].formatted_address;
        setAddress(formattedAddress);
        setValue("address", formattedAddress);
      } else {
        setAddress("Address not found");
        setValue("address", "Address not found");
      }
    } catch (error) {
      console.error("Error fetching address:", error);
      setAddress("Error fetching address");
      setValue("address", "Error fetching address");
    } finally {
      setLoading(false);
    }
  };

  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setLatitude(lat);
    setLongitude(lng);
    setValue("latitude", lat);
    setValue("longitude", lng);
    setValue(
      "google_map_location",
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`
    );
    fetchAddress(lat, lng);
  };

  const onSubmit = (data) => {
    if (selectedFile.length < 2) {
      showSnackbar("Please select at least 2 images.", "error");
      return;
    }
    if (proofSelectedFile.length < 2) {
      showSnackbar("Please upload at least 2 proof files.", "error");
      return;
    }

    const formData = {
      ...data,
      shop_open_and_close_time: `${formatToAMPM(
        data?.open_time
      )} to ${formatToAMPM(data?.close_time)}`,
      bar_img_url: selectedFile,
      govt_img_url: proofSelectedFile,
      region: "",
      wholesaler_id: WholesalerId,
    };

    dispatch(barClubAddRequest(formData));
  };

  useEffect(() => {
    dispatch(barClubResetState());
  }, [dispatch]);

  const resetFileInputs = () => {
    setSelectedFile([]);
    setImagePreview(null);
    setImageFileName("");
    if (fileInputRef.current) fileInputRef.current.value = "";

    setProofSelectedFile([]);
    setProofPreview(null);
    setProofFileName("");
    if (proofInputRef.current) proofInputRef.current.value = "";
  };

  const handleBarClubResponse = () => {
    if (addBarClubState?.error) {
      const errorMessage = addBarClubState?.errormessage;
      const errorFields = addBarClubState?.errorFields || {};

      if (Object.keys(errorFields).length > 0) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
      } else {
        let fieldErrorHandled = false;

        if (errorMessage.includes("longitude")) {
          setError("longitude", {
            type: "manual",
            message:
              "Invalid longitude value. Please enter a valid decimal number.",
          });
          fieldErrorHandled = true;
        } else if (errorMessage.includes("latitude")) {
          setError("latitude", {
            type: "manual",
            message:
              "Invalid latitude value. Please enter a valid decimal number.",
          });
          fieldErrorHandled = true;
        }

        if (!fieldErrorHandled) {
          const customMessage = mapBackendMessage(
            errorMessage || "An error occurred while updating details."
          );
          setDialogMessage(customMessage);
          setIsSuccess(false);
          setDialogOpen(true);
        }
      }
    } else if (addBarClubState?.success) {
      setDialogMessage("Bar Details Added Successfully");
      setIsSuccess(true);
      setDialogOpen(true);
      reset();
      resetFileInputs();
      dispatch(barClubResetState());
    }
  };

  useEffect(handleBarClubResponse, [addBarClubState]);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={7}>
            <Typography
              variant="h5"
              gutterBottom
              sx={styles.title}
              className="headingTable"
            >
              <h1> Register New Bar/Club </h1>
            </Typography>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={3}>
            <Box sx={styles.addBackButtonDisplay}>
              <Button
                variant="contained"
                sx={styles.addBackButtonColor}
                startIcon={<ArrowBackIcon />}
                onClick={() => {
                  dispatch(barClubResetState());
                  navigate(APP_LINKS.BARCLUBAGGREGATION);
                }}
              >
                Back
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
            <Box>
              <Typography variant="p" gutterBottom sx={styles.photoHeading}>
                Add Minimum 2 Images Bar/Club
              </Typography>
            </Box>
            <Box>
              <StyledContainer>
                <Grid container spacing={6}>
                  {imagePreview?.length > 0 ? (
                    imagePreview?.map((preview, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={2}
                        xl={2}
                        key={index}
                      >
                        <Box sx={styles.imageUploadClosePosition}>
                          <img
                            src={preview}
                            alt={`Preview ${index}`}
                            width={80}
                            height={80}
                            style={styles.imageUploadCloseContain}
                          />
                          {/* Close button */}
                          <button
                            type="button"
                            onClick={() =>
                              removeImageAdd(
                                index,
                                setSelectedFile,
                                setImagePreview
                              )
                            }
                            style={styles.imageUploadClose}
                          >
                            <CloseIcon fontSize="small" />
                          </button>
                        </Box>
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
                      <img
                        src={uploadImage}
                        alt="Proof Image"
                        width={80}
                        height={80}
                        style={styles.image}
                      />
                    </Grid>
                  )}

                  <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                    <Typography
                      variant="p"
                      gutterBottom
                      sx={styles.photoContent}
                    >
                      Upload Actual Photos of Bar/Club, size less than 2MB
                    </Typography>
                    <Box sx={styles.fileButtonContainer}>
                      <CustomButton
                        variant="outlined"
                        component="label"
                        size="small"
                        buttonStyle="chooseFileButton"
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          ref={fileInputRef}
                          onChange={handleImageUpload}
                        />
                      </CustomButton>
                      <CustomButton
                        variant="contained"
                        size="small"
                        buttonStyle="fileNameButton"
                        selectedFile={Boolean(selectedFile)}
                      >
                        {imageFileName || "No File Chosen"}
                      </CustomButton>
                    </Box>
                    <Box sx={styles.saveButtonContainer}>
                      {/* <CustomButton
                        text="Save"
                        buttonStyle="saveButton"
                        onClick={handleImage}
                        size="small"
                      >
                        Save
                      </CustomButton> */}
                    </Box>
                  </Grid>
                </Grid>
              </StyledContainer>
            </Box>
            <Box>
              <Typography variant="body2" gutterBottom sx={styles.note}>
                <span style={{ color: "red" }}>Note:</span> Only JPEG or PNG
                format is supported <span style={{ color: "red" }}>*</span>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
            <Box>
              <Typography variant="p" gutterBottom sx={styles.photoHeading}>
                Upload Minimum 2 Govt ID Proof Of Bar/club
              </Typography>
              <StyledContainer>
                <Grid container spacing={6}>
                  {proofPreview?.length > 0 ? (
                    proofPreview?.map((preview, index) => {
                      const file = proofSelectedFile?.[index];
                      const isPdf =
                        (typeof file === "string" &&
                          proofPreview[index] === pdfImage) ||
                        (file instanceof File &&
                          file.type === "application/pdf");

                      return (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={2}
                          xl={2}
                          key={index}
                        >
                          <Box sx={styles.imageUploadClosePosition}>
                            {isPdf ? (
                              <img
                                src={pdfImage}
                                alt={`Proof ${index}`}
                                width={80}
                                height={80}
                                style={styles.imageUploadCloseContain}
                                onClick={() => {
                                  if (file instanceof File) {
                                    const fileUrl = URL.createObjectURL(file);
                                    window.open(fileUrl, "_blank");
                                  } else {
                                    console.error("Invalid PDF file:", file);
                                  }
                                }}
                              />
                            ) : (
                              <img
                                src={preview}
                                alt={`Proof ${index}`}
                                width={80}
                                height={80}
                                style={styles.imageUploadCloseContain}
                              />
                            )}

                            {/* Remove button */}
                            <button
                              type="button"
                              onClick={() =>
                                removeProofImageAdd(
                                  index,
                                  setProofSelectedFile,
                                  setProofPreview
                                )
                              }
                              style={styles.imageUploadClose}
                            >
                              <CloseIcon fontSize="small" />
                            </button>
                          </Box>
                        </Grid>
                      );
                    })
                  ) : (
                    <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
                      <img
                        src={uploadImage}
                        alt="Proof Image"
                        width={80}
                        height={80}
                        style={styles.image}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                    <Typography
                      variant="p"
                      gutterBottom
                      sx={styles.photoContent}
                    >
                      Upload Actual Photos of Proof, size less than 2MB
                    </Typography>
                    <Box sx={styles.fileButtonContainer}>
                      <CustomButton
                        text="Choose File"
                        variant="outlined"
                        component="label"
                        size="small"
                        buttonStyle="chooseFileButton"
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          ref={proofInputRef}
                          onChange={handleProofUpload}
                        />
                      </CustomButton>
                      <CustomButton
                        variant="contained"
                        size="small"
                        buttonStyle="fileNameButton"
                        selectedFile={Boolean(proofSelectedFile)}
                      >
                        {proofFileName || "No File Chosen"}
                      </CustomButton>
                    </Box>
                    <Box sx={styles.saveButtonContainer}>
                      {/* <CustomButton
                        text="Save"
                        buttonStyle="saveButton"
                        onClick={proofImage}
                        size="small"
                      >
                        Save
                      </CustomButton> */}
                    </Box>
                  </Grid>
                </Grid>
              </StyledContainer>
            </Box>
            <Typography variant="body2" gutterBottom sx={styles.note}>
              <span style={{ color: "red" }}>Note:</span> Only JPEG, PDF & PNG
              format is supported <span style={{ color: "red" }}>*</span>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
              setValue={setValue}
              required={true}
              onFieldClick={handleOpenMap}
            />
            {/* Submit Button */}
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Submit"
                    size="medium"
                    type="submit"
                    buttonStyle="StyledButton"
                    disabled={addBarClubState?.inProgress}
                    loading={addBarClubState?.inProgress}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomButton
                    text="Cancel"
                    variant="contained"
                    size="medium"
                    fullWidth
                    buttonStyle="style1"
                    onClick={handleCancel}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>
      {/* Snackbar */}
      <CommonSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />

      {/* Dialog */}
      <CommonDialog
        open={dialogOpen}
        isSuccess={isSuccess}
        onClose={handleDialogClose}
        messageSuccess={dialogMessage}
        messageError={dialogMessage}
      />

      <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Your form elements here */}

          {/* Modal for Map */}
          <Modal
            open={openMap}
            onClose={handleCloseMap}
            aria-labelledby="map-modal-title"
            aria-describedby="map-modal-description"
          >
            <Box
              sx={{
                p: 2,
                bgcolor: "white",
                borderRadius: "8px",
                maxWidth: "600px",
                mx: "auto",
                mt: "10%",
              }}
            >
              <h2 id="map-modal-title">Select Location</h2>
              <GoogleMap
                mapContainerStyle={{ width: "100%", height: "400px" }}
                center={{ lat: 12.9716, lng: 77.5946 }}
                zoom={10}
                onClick={handleMapClick}
              >
                {latitude && longitude && (
                  <Marker
                    position={{
                      lat: parseFloat(latitude),
                      lng: parseFloat(longitude),
                    }}
                  />
                )}
              </GoogleMap>
            </Box>
          </Modal>
        </form>
      </LoadScript>
    </Container>
  );
};

export default AddClub;
